import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { ImpactMetrics } from './components/ImpactMetrics';
import { Expertise } from './components/Expertise';
import { Experience } from './components/Experience';
import { Recognition } from './components/Recognition';
import { Education } from './components/Education';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-navy text-charcoal selection:bg-gold/30 selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <About data-id="element-4" />
        <ImpactMetrics data-id="element-5" />
        <Expertise data-id="element-6" />
        <Experience data-id="element-7" />
        <Recognition data-id="element-8" />
        <Education data-id="element-9" />
        <Contact data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}